module.exports = __webpack_public_path__ + "static/media/logo-color.9e465978.png";